// extracted by mini-css-extract-plugin
export var actionText = "_rv-4";
export var container = "_rv-0";
export var leftSection = "_rv-1";
export var rightSection = "_rv-2";
export var settingsButton = "_rv-6";
export var settingsIcon = "_rv-7";
export var shortcut = "_rv-5";
export var shortcutGroup = "_rv-3";